var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20215 12C3.20215 6.61704 7.56918 2.25 12.9521 2.25C18.3351 2.25 22.7021 6.61704 22.7021 12C22.7021 17.383 18.3351 21.75 12.9521 21.75C7.56918 21.75 3.20215 17.383 3.20215 12ZM12.9521 3.75C8.39761 3.75 4.70215 7.44546 4.70215 12C4.70215 16.5545 8.39761 20.25 12.9521 20.25C17.5067 20.25 21.2021 16.5545 21.2021 12C21.2021 7.44546 17.5067 3.75 12.9521 3.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3575 6.96967C15.6504 7.26256 15.6504 7.73744 15.3575 8.03033L11.3878 12L15.3575 15.9697C15.6504 16.2626 15.6504 16.7374 15.3575 17.0303C15.0646 17.3232 14.5897 17.3232 14.2968 17.0303L9.79682 12.5303C9.50393 12.2374 9.50393 11.7626 9.79682 11.4697L14.2968 6.96967C14.5897 6.67678 15.0646 6.67678 15.3575 6.96967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/BackArrow.43bbf7558d4eb8b86ef820918ee8418d.svg";
export { ForwardRef as ReactComponent };